// extracted by mini-css-extract-plugin
module.exports = {"page":"index_page__dyPfK","img":"index_img__3yROQ","text":"index_text__1-0bb"};